import { Modal, Button } from "antd";
import React from "react";
import TextInfo from "../../../../components/common/TextInfo/TextInfo";

// import "./styles.css";

const DetailCampaignDialog = ({ visible, handleCancel, data }) => {
  return (
    <Modal
      className="modal-detail"
      title="Detail Offer"
      visible={visible}
      onCancel={handleCancel}
      width={500}
      centered
      footer={[
        <Button
          key="back"
          onClick={handleCancel}
          className="btn-modal btn-default"
        >
          Kembali
        </Button>,
      ]}
    >
      <div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "200px auto",
            gap: "5px",
          }}
        >
          {/* <TextInfo title="Tanggal/Waktu digunakan" value={""} /> */}
          <TextInfo title="Nama Offer" value={data?.offer?.name || "-"} />
          <TextInfo title="Jenis Gadai" value={data?.offer?.gadaiType || "-"} />
          <TextInfo
            title="Kategori Produk"
            value={data?.offer?.category || "-"}
          />
          <TextInfo title="Outlet/Cabang" value={data?.offer?.outlet || "-"} />
          <TextInfo title="Jenis Tenor" value={data?.offer?.tenorType || "-"} />
          <TextInfo
            title="Jenis Pembayaran"
            value={data?.offer?.paymentType || "-"}
          />
          {
            data?.offer?.paymentType === 'Installment' ?
              <>
                <TextInfo
                  title="Periode"
                  value={data?.offer?.period || "-"}
                />
                <TextInfo
                  title="Hari Per Periode"
                  value={data?.offer?.tenorPerPeriod || "-"}
                />
              </> :
              <TextInfo title="Tenor Pinjaman" value={data?.offer?.tenor} />
          }
          <TextInfo
            title="Minimum Pinjaman"
            value={data?.offer?.minLoan || "-"}
          />
          <TextInfo
            title="Maksimum Pinjaman"
            value={data?.offer?.maxLoan || "-"}
          />
          <TextInfo
            title="Sewa Modal"
            value={data?.offer?.capitalLoan || "-"}
          />
          <TextInfo
            title="Biaya Administrasi"
            value={data?.offer?.feeAdmin || "-"}
          />
          <TextInfo
            title="Biaya Simpan & Asuransi"
            value={data?.offer?.feeSavingInsurance || "-"}
          />
          {data?.offer?.type === "loan" ? (
            <>
              <TextInfo
                title="Biaya Denda Keterlambatan"
                value={data?.offer?.feeLateCharge || "-"}
              />
              <TextInfo
                title="Biaya Keterlambatan"
                value={data?.offer?.feeLatePeriod || "-"}
              />
              <TextInfo
                title="Biaya Jasa Lelang"
                value={data?.offer?.feeAuction || "-"}
              />
              <TextInfo
                title="Maksimum Perpanjangan"
                value={data?.offer?.maxExtend || "-"}
              />
              <TextInfo
                title="Maksimum Keterlambatan"
                value={data?.offer?.maxLate || "-"}
              />
            </>
          ) : (
            <>
              <TextInfo
                title="Nilai Revaluasi"
                value={data?.offer?.revaluation || "-"}
              />
              <TextInfo
                title="Izinkan Ubah Valuasi"
                value={data?.offer?.isAllowChangeValuation || "-"}
              />
            </>
          )}
          <TextInfo
            title="Masa Tenggang"
            value={data?.offer?.gracePeriod || "-"}
          />
        </div>
      </div>
    </Modal>
  );
};

export default DetailCampaignDialog;
